/* SweetAlert2 */
window.Promise = require('es6-promise').Promise;
window.swal = require('sweetalert2');

window.confirmDelete = function (idName) {
    swal({
        title: '削除してよろしいですか?',
        text: "削除すると二度と戻りません!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: '削除',
        cancelButtonText: "キャンセル"
    }).then(function () {
        const id = "#" + idName
        $('' + id).submit();
    })
}

//メール送信確認用
window.confirmSendMail = function (url) {
    swal({
        title: 'メールを送信しますか?',
        text: "登録フォームのURLが記載されたメールを送信します",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: '送信',
        cancelButtonText: "キャンセル"
    }).then(function () {
        location.href = url;
    })
}